import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '@processo/services/token.service';
import { StateService } from '@processo/shared/state/state.service';

export const authGuard: CanActivateFn = () => {
  const state = inject(StateService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  if (state.isUserLoggedIn().loggedIn) {
    return true;
  } else {
    state.clearState();
    tokenService.clearTokens();
    const currentUrl = (typeof window !== 'undefined' && window.location)
      ? `${window.location.pathname}${window.location.search}`
      : '/';
    
    router.navigate(['/login'], {
      queryParams: {
        redirect: currentUrl,
      },
    });
    return false;
  }
};
